var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.946 0L19.9399 17.8891C20.0011 18.9919 19.1567 19.9357 18.0539 19.9969C18.0262 19.9982 18.0123 19.9988 17.9984 19.9992C17.9846 19.9996 17.9707 19.9997 17.9429 20H2.05713C0.952559 20 0.0571289 19.1046 0.0571289 18C0.0576423 17.9445 0.0576423 17.9445 0.0602082 17.8891L1.05404 0H18.946ZM2.94602 2L2.05713 18H17.9429L17.054 2H2.94602ZM7.00003 4H5.00003V6.5C5.00003 8.9007 7.32327 11 10 11C12.6768 11 15 8.9007 15 6.5V4H13V6.5C13 7.74837 11.6149 9 10 9C8.38517 9 7.00003 7.74837 7.00003 6.5V4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.873976fe.svg";
export { ForwardRef as ReactComponent };